import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { CommentableTypes } from '../../../Comment/redux/types';
import ThreadOrderSelect from '../ThreadOrderSelect';
import { OnOrderChangedFunction } from '../../types';
import s from './ThreadHeader.scss';

export interface Props {
  commentableTypeId: CommentableTypes;
  commentableItemId: number;
  parentId?: number;
  total?: number;
  withTitle?: boolean;
  withOrder?: boolean;
  className?: string;
  children: React.ReactNode;
  onOrderChanged?: OnOrderChangedFunction;
}

const ThreadHeader: React.FC<Props> = ({
  total,
  commentableTypeId,
  commentableItemId,
  parentId,
  withOrder = true,
  withTitle = true,
  className,
  children,
  onOrderChanged,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { isLoggedIn } = useContext(SessionContext);

  if (!withOrder && !withTitle) {
    return null;
  }

  return (
    <>
      <Flex className={className} alignItems="center">
        <div>
          {withTitle && (
            <>
              <span className={s['title']}>
                {t('commentthread.control.comments')}
              </span>
              {total !== undefined && (
                <span className={s['total']}>{total}</span>
              )}
            </>
          )}
        </div>
        {!isMobile && <>{children}</>}
        {withOrder && isLoggedIn && (
          <ThreadOrderSelect
            commentableItemId={commentableItemId}
            commentableTypeId={commentableTypeId}
            parentId={parentId}
            onOrderChanged={onOrderChanged}
          />
        )}
      </Flex>
      {isMobile && <Flex>{children}</Flex>}
    </>
  );
};
ThreadHeader.displayName = 'ThreadHeader';

export default ThreadHeader;
